import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "@/locales/en.json";
import zhHans from "@/locales/zh-Hans.json";
import zhHant from "@/locales/zh-Hant.json";
import {
  persistLocale,
  resolveInitialLocale,
  type AppLocale,
} from "./locale";

const initialLocale = resolveInitialLocale();
persistLocale(initialLocale);

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    "zh-Hans": { translation: zhHans },
    "zh-Hant": { translation: zhHant },
  },
  lng: initialLocale,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
  returnNull: false,
});

export const changeAppLocale = (locale: AppLocale): void => {
  persistLocale(locale);
  void i18n.changeLanguage(locale);
};

export default i18n;
